import { useState, useEffect } from 'react';
import type {
  MeshAnalysisResult,
  MeshAnalysisMessage,
} from '@/worker/meshAnalysis.worker';

export function useMeshAnalysis(blob: Blob | null) {
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [result, setResult] = useState<MeshAnalysisResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setResult(null);
      setError(null);
      setIsAnalyzing(false);
      return;
    }

    setIsAnalyzing(true);
    setError(null);

    const worker = new Worker(
      new URL('@/worker/meshAnalysis.worker.ts', import.meta.url),
      { type: 'module' },
    );

    worker.onmessage = (e: MessageEvent<MeshAnalysisMessage>) => {
      const data = e.data;
      if (data.type === 'success') {
        setResult(data.result);
      } else {
        setError(data.error);
      }
      setIsAnalyzing(false);
    };

    worker.onerror = (e) => {
      setError('An error occurred during mesh analysis.');
      setIsAnalyzing(false);
    };

    worker.postMessage({ blob });

    return () => {
      worker.terminate();
    };
  }, [blob]);

  return { isAnalyzing, result, error };
}
